export default function AgreementStep() {
  return (
    <>
      <h3>Service Agreement</h3>

      <label>
        <input type="checkbox" />
        I confirm that the services agreement has been signed
      </label>

      <a href="/intake/submitted" className="btn primary">
        Submit Project Intake
      </a>
    </>
  );
}
